export const HOME_SELECT_CITY_ID = 'cityDropdown';
